var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#1B2646;stroke-width:0.75;}\n\t.st1{fill:none;stroke:#1B2646;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,14.2h0.4v-0.4v-4c0-0.3,0.1-0.5,0.3-0.7c0.2-0.2,0.4-0.3,0.7-0.3H18c0.8,0,1.6,0.3,2.2,0.9 c0.6,0.6,0.9,1.4,0.9,2.2v5.8h-0.6v-2.4v-0.4h-0.4H3.4H3v0.4v2.4H2.4V7.4H3v6.5v0.4h0.4L11,14.2L11,14.2z M20.1,14.2h0.4v-0.4v-2.1 l0,0c0-0.6-0.3-1.3-0.7-1.7c-0.5-0.5-1.1-0.7-1.7-0.7l0,0h-5.6h-0.4v0.4v4.1v0.4h0.4C12.5,14.2,20.1,14.2,20.1,14.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.3,8.6L7.3,8.6C6.7,8.6,6.4,8.7,6.1,9c-0.3,0.3-0.5,0.7-0.5,1.1l0,0c0,0.3,0.1,0.6,0.3,0.9 c0.2,0.3,0.4,0.4,0.7,0.6s0.6,0.1,0.9,0.1c0.3-0.1,0.6-0.2,0.8-0.4c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.3,0-0.6-0.1-0.9 C8.6,9.2,8.4,9,8.1,8.8C7.9,8.7,7.6,8.6,7.3,8.6z M6.1,8.5c0.3-0.2,0.7-0.3,1.1-0.3c0.5,0,1,0.2,1.3,0.6C9,9.2,9.2,9.6,9.2,10.1 c0,0.4-0.1,0.7-0.3,1.1c-0.2,0.3-0.5,0.6-0.9,0.7C7.6,12,7.3,12,6.8,12c-0.4-0.1-0.7-0.3-1-0.5c-0.3-0.3-0.4-0.6-0.5-1 c-0.1-0.4,0-0.8,0.1-1.1C5.5,9,5.8,8.7,6.1,8.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedDark);
export default __webpack_public_path__ + "static/media/bed-dark.49c0471d12add8e1c607c2a04e7e497e.svg";
export { ForwardRef as ReactComponent };